import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import Menu from "../../Components/Menu";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import InfiniteScroll from "react-infinite-scroll-component";
import ReturnModal from "../../Components/ReturnModal";

const ReturnOrder = () => {
    const navigate = useNavigate();
    let token;
    let user;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
        user = localStorage.getItem("user");
    }
    useEffect(() => {
        document.title = "ویزیت | برگشت کالا";
        token == null && navigate("/login", { replace: true });
    }, []);
    const { orderId } = useParams();
    const [productList, setProductList] = useState([]);
    const [pages, setPages] = useState([]);
    const [numPages, setNumPages] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [cartLoading, setCartLoading] = useState(false);
    const productHandler = () => {
        let config = {
            url: `${baseUrl}/orders/${orderId}/return`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                setCartLoading(false);
                res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.products &&
                    setProductList(
                        res.data.data.products.map((item) => ({
                            ...item,
                            num: item.order_count,
                        }))
                    );
                res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.paginate &&
                    setPages(res.data.data.paginate);
            })
            .catch((err) => {
                setCartLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        productHandler();
    }, []);
    useEffect(() => {
        let total = pages.totalItems;
        const totalPagesCount = Math.ceil(total / 10);
        setNumPages(
            Array.from({ length: totalPagesCount }, (_, index) => index + 1)
        );
    }, [pages]);

    const pageHandler = () => {
        let data = new FormData();
        let config = {
            url: `${baseUrl}/orders/${orderId}/edit?page=${pages.nextPage}`,
            method: "GET",
        };
        numPages.length >= pages.nextPage &&
            axios(config)
                .then((res) => {
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.products &&
                        setProductList((prevData) => [
                            ...prevData,
                            ...res.data.data.products.map((item) => ({
                                ...item,
                                num: item.order_count,
                            })),
                        ]);
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.paginate &&
                        setPages(res.data.data.paginate);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                });
        numPages.length < pages.nextPage && setHasMore(false);
    };

    // Filter
    const [itemToReturn, setItemToReturn] = useState([]);
    const [showReturnModal, setShowReturnModal] = useState(false);
    return (
        <div className="container">
            {showReturnModal && (
                <ReturnModal id={orderId} item={itemToReturn} />
            )}
            <div className="product-main">
                {showReturnModal && (
                    <div
                        onClick={() => {
                            setShowReturnModal(false);
                        }}
                        id="bg_gray"
                        className="bg-gray"
                    ></div>
                )}
                <InfiniteScroll
                    dataLength={productList.length}
                    next={pageHandler}
                    hasMore={hasMore}
                    loader={
                        productList.length !== 0 && (
                            <div className="mx-auto d-flex justify-content-center mt-4">
                                <img
                                    src="/assets/images/loading.gif"
                                    width={40}
                                />
                            </div>
                        )
                    }
                >
                    {productList !== undefined &&
                        productList !== null &&
                        productList.length !== 0 &&
                        productList.map((item) => {
                            return (
                                <div key={item.id} className="product-card">
                                    <div className="row-1">
                                        <div className="img-div">
                                            <img src={item.Image} alt="" />
                                        </div>
                                        <div>
                                            <div className="marquee">
                                                <h4
                                                    className={
                                                        item.name.length < 13
                                                            ? "name"
                                                            : item.name.length <
                                                              25
                                                            ? "name moving-2"
                                                            : "name moving"
                                                    }
                                                >
                                                    <span>{item.name}</span>
                                                </h4>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="price-span-1">
                                                    قیمت واحد:
                                                </span>
                                                <span className="price-span-2">
                                                    {Number(
                                                        item.unit_price
                                                    ).toLocaleString()}{" "}
                                                    تومان
                                                </span>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="muted-span-1">
                                                    قیمت فروشگاه:
                                                </span>
                                                <span className="muted-span-2">
                                                    {Number(
                                                        item.store_price
                                                    ).toLocaleString()}{" "}
                                                    تومان
                                                </span>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="muted-span-1">
                                                    قیمت مصرف کننده:
                                                </span>
                                                <span className="muted-span-2">
                                                    {Number(
                                                        item.consumer_price
                                                    ).toLocaleString()}{" "}
                                                    تومان
                                                </span>
                                            </div>
                                            <div className="d-flex-center">
                                                <span className="muted-span-1">
                                                    تعداد در واحد:
                                                </span>
                                                <span className="muted-span-2">
                                                    {item.unit_count}{" "}
                                                    {item.measure_unit.name}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row-2">
                                        <div className="inventory">
                                            <svg
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M10.9999 4.58325L6.92992 1.83325L1.83325 5.49992L5.90325 8.24992L10.9999 4.58325Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11 4.58325L15.07 1.83325L20.1667 5.49992L16.0967 8.24992L11 4.58325Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10.9999 12.8334L6.92992 15.5834L1.83325 11.9167L5.90325 9.16675L10.9999 12.8334Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11 12.8334L15.07 15.5834L20.1667 11.9167L16.0967 9.16675L11 12.8334Z"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    opacity="0.4"
                                                    d="M17.4166 14.2083V17.2057L11.3849 19.9924C11.1374 20.1024 10.8624 20.1024 10.6149 19.9924L4.58325 17.2057V14.2083"
                                                    stroke="black"
                                                    strokeWidth="1.5"
                                                    strokeMiterlimit="10"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <span>موجودی:</span>
                                            <span className="inv-num">
                                                {item.inventory}
                                            </span>
                                        </div>
                                        <div className="count">
                                            <span className="blue-cir-c">
                                                {item.num}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex-center pro-row">
                                        <div className="d-flex-center">
                                            <div className="price-blue min-w-160">
                                                <svg
                                                    width="21"
                                                    height="21"
                                                    viewBox="0 0 21 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g opacity="0.4">
                                                        <path
                                                            d="M7.4375 12.4688C7.4375 14.1487 8.82 15.5312 10.5 15.5312C12.18 15.5312 13.5625 14.1487 13.5625 12.4688"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M7.70827 1.75L4.54077 4.92625"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M13.2908 1.75L16.4583 4.92625"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </g>
                                                    <path
                                                        d="M1.75 6.86865C1.75 5.2499 2.61625 5.11865 3.6925 5.11865H17.3075C18.3838 5.11865 19.25 5.2499 19.25 6.86865C19.25 8.7499 18.3838 8.61865 17.3075 8.61865H3.6925C2.61625 8.61865 1.75 8.7499 1.75 6.86865Z"
                                                        stroke="#0085FF"
                                                        strokeWidth="1.5"
                                                    />
                                                    <path
                                                        d="M3.0625 8.75L4.29625 16.31C4.57625 18.0075 5.25 19.25 7.7525 19.25H13.0288C15.75 19.25 16.1525 18.06 16.4675 16.415L17.9375 8.75"
                                                        stroke="#0085FF"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                                <span className="price-n">
                                                    {Number(
                                                        item.unit_price *
                                                            item.num
                                                    ).toLocaleString()}
                                                </span>
                                                <span>تومان</span>
                                            </div>
                                            {item.discount_percent
                                                ? item.discount_percent !==
                                                      0 && (
                                                      <span className="discount">
                                                          {
                                                              item.discount_percent
                                                          }
                                                          %
                                                      </span>
                                                  )
                                                : ""}
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => {
                                            setItemToReturn(item);
                                            setShowReturnModal(true);
                                        }}
                                        className="pay-factor-btn return-btn-danger"
                                    >
                                        مرجوع
                                    </button>
                                </div>
                            );
                        })}
                </InfiniteScroll>
                <div className=" mt-4"></div>
                {cartLoading && (
                    <div className="add-to-cart">
                        <div className="mx-auto d-flex justify-content-center mt-4">
                            <img src="/assets/images/loading.gif" width={40} />
                        </div>
                    </div>
                )}
                <Menu active="cart" />
            </div>
        </div>
    );
};

export default ReturnOrder;
